// Mouse.js
import React from 'react';
import PropTypes from 'prop-types';
import './Mouse.css';
import Option from './Option';

const Mouse = ({
  splitLeadShared = 'Move the cursor with face gestures', // Default text
}) => {
  return (
    <div className="chunk-container-2"> 
      <div className="chunk-content">
        <h1 className="normal-title">Multiple options to move the mouse</h1>
        <div className="mouse-options">
          <Option
            title="GazeLead"
            features={[
              'Move the cursor with your gaze',
              'Train a custom AI model to Optimize performance',
              'Perfect for scenarios that require immediate input like videogames',
            ]}
          />
          <Option
            title="SplitLead"
            features={[
              splitLeadShared,
              'Robust and precise',
              'Perfect for scenarios that require accurate input like web navigation',
            ]}
          />
        </div>
      </div>
    </div>
  );
};

Mouse.propTypes = {
  splitLeadShared: PropTypes.string, // Corrected prop name
};

export default Mouse;
